import { Switch, Typography, Tooltip } from '@recruit-robin/robin-theme/web-components';
import { CandidateRequirementsDTO, QuestionKey } from 'clients/Communication/Questionnaire.dto';
import { useContext } from 'react';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { Question } from '../../CandidateQuestionnaireScreen/components/Question';
import { useStyles } from './QuestionnairePreviewDialog.styles';

export const QuestionnaireQuestionWrapper = ({
  question,
  children,
  isRequired,
  onToggleRequired,
}: {
  question: CandidateRequirementsDTO[QuestionKey];
  children: React.ReactNode;
  isRequired: boolean;
  onToggleRequired: (checked: boolean) => void;
}) => {
  const classes = useStyles({});
  const { dictionary } = useContext(LocalizationContext);

  return (
    <div css={classes.questionItem}>
      <Question
        key={question.question_key}
        question={question}
        rightAdornment={
          <Tooltip
            label={
              <Typography variant={(v) => v.supporting.helper}>
                {dictionary.pleaseReviewTheQualificationQuestions}
              </Typography>
            }
            placement="top"
            zIndex={5}>
            <Switch.Root checked={isRequired} onCheck={onToggleRequired}>
              <Switch.Label>
                <Typography variant={(v) => v.body.short}>
                  {isRequired ? dictionary.questionnaireMustHave : dictionary.questionnaireNiceToHave}
                </Typography>
              </Switch.Label>
              <Switch.Track />
            </Switch.Root>
          </Tooltip>
        }>
        {children}
      </Question>
    </div>
  );
};
